<pdq-card variant="flat" color="white">
  <pdq-expandable-section id="multi-shipment-gift-notes-block" [cacheState]="true" [initialCollapsed]="false">
    <div sectionHeader class="section-heading">
      <pdq-heading element="h6">Gift Notes Block</pdq-heading>
      <p class="body-12-regular section-heading__subtitle">
        Shown in single-address checkout, where the buyer adds handwritten cards for this shipment.
      </p>
    </div>

    <div class="gift-notes-block" [formGroup]="formGroup">
      <pdq-input
        label="Section title"
        formControlName="title"
        placeholder="Gift notes"
        [invalid]="formGroup.controls.title.dirty && formGroup.controls.title.invalid"
        invalidMsg="Section title is required"></pdq-input>
      <div class="field">
        <p class="body-14-medium">Section description</p>
        <rich-textarea
          [initialContent]="formGroup.controls.description.value"
          (contentChange)="onRichTextChange(formGroup.controls.description, $event)"
          placeholder="Optional handwritten cards for the gifts in this shipment."></rich-textarea>
      </div>

      <div class="subsection" formGroupName="addGiftNoteCard">
        <div class="subsection__heading">
          <p class="body-14-medium">Add gift note card</p>
          <p class="body-12-regular section-heading__subtitle">Invites the buyer to add a gift note</p>
        </div>
        <pdq-input
          label="Card title"
          formControlName="title"
          placeholder="Add a gift note"
          [invalid]="addGiftNoteCard.controls.title.dirty && addGiftNoteCard.controls.title.invalid"
          invalidMsg="Card title is required"></pdq-input>
        <div class="field">
          <p class="body-14-medium">Card help text</p>
          <rich-textarea
            [initialContent]="addGiftNoteCard.controls.helpText.value"
            (contentChange)="onRichTextChange(addGiftNoteCard.controls.helpText, $event)"
            placeholder="Include a handwritten card with the gifts in this shipment."
            [invalid]="addGiftNoteCard.controls.helpText.dirty && addGiftNoteCard.controls.helpText.invalid"
            errorMsg="Card help text is required"></rich-textarea>
        </div>
        <pdq-input
          label="Button label"
          formControlName="buttonLabel"
          placeholder="Add note"
          [invalid]="addGiftNoteCard.controls.buttonLabel.dirty && addGiftNoteCard.controls.buttonLabel.invalid"
          invalidMsg="Button label is required"></pdq-input>
      </div>

      <div class="subsection" formGroupName="addAnotherGiftNoteCard">
        <pdq-checkbox
          formControlName="enabled"
          label="Different copy for further gift notes"
          secondaryLabel="When off, the card above is reused once a note exists."></pdq-checkbox>
        @if (addAnotherGiftNoteCard.controls.enabled.value) {
          <pdq-input
            label="Card title"
            formControlName="title"
            placeholder="Add another gift note"
            [invalid]="addAnotherGiftNoteCard.controls.title.dirty && addAnotherGiftNoteCard.controls.title.invalid"
            invalidMsg="Card title is required"></pdq-input>
          <div class="field">
            <p class="body-14-medium">Card help text</p>
            <rich-textarea
              [initialContent]="addAnotherGiftNoteCard.controls.helpText.value"
              (contentChange)="onRichTextChange(addAnotherGiftNoteCard.controls.helpText, $event)"
              placeholder="Include a handwritten card with the gifts in this shipment."
              [invalid]="
                addAnotherGiftNoteCard.controls.helpText.dirty && addAnotherGiftNoteCard.controls.helpText.invalid
              "
              errorMsg="Card help text is required"></rich-textarea>
          </div>
          <pdq-input
            label="Button label"
            formControlName="buttonLabel"
            placeholder="Add note"
            [invalid]="
              addAnotherGiftNoteCard.controls.buttonLabel.dirty && addAnotherGiftNoteCard.controls.buttonLabel.invalid
            "
            invalidMsg="Button label is required"></pdq-input>
        }
      </div>
    </div>
  </pdq-expandable-section>
</pdq-card>
